module.exports = __webpack_public_path__ + "img/horizontal_3_7_3016.164ec2f0.png";